import { useCallback, useMemo, useState } from 'react';

import qs from 'qs';
import useSWR from 'swr';
import { IProductsFilter } from 'types/IProductsFilter';

import {
  getProductsFilters,
  TGetProductsFiltersParams,
} from 'services/api/productService';

type TSelectedFilters = Record<string, string[]>;

interface IUseProductsFiltersProps {
  params?: TGetProductsFiltersParams;
}

interface IUseProductsFiltersResponse {
  filters: IProductsFilter[];
  isLoading: boolean;
  selectedFilters: TSelectedFilters;
  selectFilter(id: string, optionId: string): void;
}

export function useProductsFilters(
  props?: IUseProductsFiltersProps
): IUseProductsFiltersResponse {
  const { params } = props || {};

  const [selectedFilters, setSelectedFilters] = useState(
    {} as TSelectedFilters
  );

  const { data, error } = useSWR(
    `products-filters${qs.stringify(params)}`,
    () => getProductsFilters(params)
  );

  const filters = useMemo(() => data || [], [data]);

  const selectFilter = useCallback((id: string, optionId: string) => {
    setSelectedFilters((prevState) => {
      const alreadyIsSelected = prevState?.[id]?.includes(optionId);

      if (alreadyIsSelected) {
        return {
          ...prevState,
          [id]: prevState[id].filter((option) => option !== optionId),
        };
      }
      return {
        ...prevState,
        [id]: [...(prevState[id] || []), optionId],
      };
    });
  }, []);

  return { filters, isLoading: !data && !error, selectedFilters, selectFilter };
}
